import * as React from "react";
import { Container } from "react-bootstrap";
import Seo from "../components/Seo";

import { teamPageTplData } from "../data/page-tpl-team.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";

import PageHead from "../components/Page/PageHead";
import Team from "../components/Team";
import TeamHeader from "../components/TeamHeader";
import Hero from "../componentsSections/Hero";

const PageTeam = ({ pageContext: { id } }) => {
    const pageData = teamPageTplData(id);
    const seoPageData = getCurrentPageSeo(id);

    return (
        <Layout pageTitle={seoPageData.title}>
            <Seo post={seoPageData} />
            {/* HERO */}
            <Hero
                {...pageData.hero}
                textSize="big"
                className="-leadership -full-width-copy"
            />

            {/* Page head */}
            <Container>
                <PageHead {...pageData.pageHeader} />
            </Container>

            {/* Team Section Header*/}
            <Section className="-small-margin-bottom">
                <Container>
                    <TeamHeader {...pageData.additionalInfo} />
                </Container>
            </Section>

            {/* Team Section Cards*/}
            <Section className="-small-margin-bottom team">
                <Container>
                    <Team />
                </Container>
            </Section>

            <PageFooterSections pageData={pageData} />
        </Layout>
    );
};

export default PageTeam;
